<template>

    <span>
        <slot name="actions"></slot>
        <ButtonsEditIcon v-if="!noDefaultActions && !hideBtnEdit" @clicked="emit('clickedEditButton')"/>
        <ButtonsDeleteIcon v-if="!noDefaultActions && !hideBtnDelete" @clicked="emit('clickedDeleteButton')"/>
    </span>

</template>

<script setup>

import { defineEmits, defineProps } from 'vue';

const emit = defineEmits(['clickedEditButton', 'clickedDeleteButton'])
const props = defineProps({
    noDefaultActions: { type: Boolean, default: false },
    hideBtnDelete: { type: Boolean, default: false },
    hideBtnEdit: { type: Boolean, default: false },
})

</script>